/**
 * 车辆，全部/询价/拍卖  ---车辆管理
 * http://mockjs.com/
url： https://testzsqy.cheanjia.com/?mock=1#/sms/4
 */
import Mock from 'mockjs'
import cache from '../../common/cache'
let mock = cache.getSessionData('mock')
// mock 开关
let mockSwitch = mock ? '' : '_'
// 接口地址  /api/v1/auctions/{auction_car_id}/delete_auction/ 编辑流程需要下架拍卖即删除
Mock.mock(/\/auctions\/\d+\/delete_auction/, 'delete' + mockSwitch, {
  'code': 0,
  'message': 'ok',
  'data': null
})
// 接口地址   /api/v1/auctions/{auction_id}/publish
Mock.mock(/\/auctions\/new_car_info/, 'post' + mockSwitch, {
  'code': 0,
  'message': 'ok',
  'data': {
    'car_info_id': 221 // 车辆信息快照的id,用于之后的提交车辆照片、车辆信息以及检测信息，以及跳转到完整车况页
  }
})

// 获取车辆管理列表
// 接口地址  /api/v1/auctions/auction_cars
Mock.mock(/auctions\/auction_cars\?/, 'get' + mockSwitch, {
  'code': 0,
  'message': 'ok',
  'data': {
    'page': 1,
    'count': 20,
    'total_count': 28,
    'auction_cars': [
      {
        'auction_car_id': 1, // 车辆id
        'latest_auction_id': 123, // 去撮合的id
        'status': 12, // 1、库存；2、已售 3、撮合已售
        'ongoing_status': 1, // 0为只在库，1为拍卖中，2为撮合中，3为询价中
        'auction_matchable': true, // 可否流拍撮合
        'enquiry_matchable': false, // 可否询价撮合
        'enquiring': true, // 是否在询价中
        'is_self_brand': false, // 是否是本品
        'date': '2018-01-01',
        'car_model_name': '汉兰达/2015款2.0T两驱精英版 5座',
        'car_image': 'http://img3.bitautoimg.com/autoalbum/files/20150324/003/16465300339630_3948382_2.jpg', // 车辆照片
        'actual_paid_amount': 2656500 // 实收金额，单位分
      },
      {
        'auction_car_id': 15, // 车辆id
        'latest_auction_id': 123, // 去撮合的id
        'status': 1, // 1、库存；2、已售 3、撮合已售
        'ongoing_status': 1, // 0为只在库，1为拍卖中，2为撮合中，3为询价中
        'auction_matchable': false, // 可否流拍撮合
        'enquiry_matchable': true, // 可否询价撮合
        'is_self_brand': true, // 是否是本品
        'enquiring': true, // 是否在询价中
        'date': '2018-01-01',
        'car_model_name': '汉兰达/2015款2.0T两驱精英版 5座',
        'car_image': 'http://img3.bitautoimg.com/autoalbum/files/20150324/003/16465300339630_3948382_2.jpg', // 车辆照片
        'actual_paid_amount': 2656500 // 实收金额，单位分
      },
      {
        'auction_car_id': 2, // 车辆id
        'latest_auction_id': 123, // 去撮合的id
        'status': 1, // 1、库存；2、已售 3、撮合已售
        'ongoing_status': 2, // 0为只在库，1为拍卖中，2为撮合中，3为询价中
        'auction_matchable': false, // 可否流拍撮合
        'enquiry_matchable': false, // 可否询价撮合
        'is_self_brand': true, // 是否是本品
        'enquiring': true, // 是否在询价中
        'date': '2017-01-10',
        'car_model_name': '汉兰达/2015款2.0T两驱精英版 5座',
        'car_image': 'http://img3.bitautoimg.com/autoalbum/files/20150324/003/16465300339630_3948382_2.jpg', // 车辆照片
        'actual_paid_amount': 2656500 // 实收金额，单位分
      },
      {
        'auction_car_id': 3, // 车辆id
        'latest_auction_id': 123, // 去撮合的id
        'status': 1, // 1、库存；2、已售 3、撮合已售
        'ongoing_status': 0, // 0为只在库，1为拍卖中，2为撮合中，3为询价中
        'auction_matchable': false, // 可否流拍撮合
        'enquiry_matchable': false, // 可否询价撮合
        'is_self_brand': true, // 是否是本品
        'enquiring': true, // 是否在询价中
        'date': '2017-01-10',
        'car_model_name': '汉兰达/2015款2.0T两驱精英版 5座',
        'car_image': 'http://img3.bitautoimg.com/autoalbum/files/20150324/003/16465300339630_3948382_2.jpg', // 车辆照片
        'actual_paid_amount': 2656500 // 实收金额，单位分
      },
      {
        'auction_car_id': 4, // 车辆id
        'latest_auction_id': 123, // 去撮合的id
        'status': 2, // 1、库存；2、已售 3、撮合已售
        'ongoing_status': 0, // 0为只在库，1为拍卖中，2为撮合中，3为询价中
        'auction_matchable': false, // 可否流拍撮合
        'enquiry_matchable': false, // 可否询价撮合
        'is_self_brand': true, // 是否是本品
        'enquiring': true, // 是否在询价中
        'date': '2015-11-11',
        'car_model_name': '汉兰达/2015款2.0T两驱精英版 5座',
        'car_image': 'http://img3.bitautoimg.com/autoalbum/files/20150324/003/16465300339630_3948382_2.jpg', // 车辆照片
        'actual_paid_amount': 2656500 // 实收金额，单位分
      },
      {
        'auction_car_id': 5, // 车辆id
        'latest_auction_id': 123, // 去撮合的id
        'status': 1, // 1、库存；2、已售 3、撮合已售
        'ongoing_status': 3, // 0为只在库，1为拍卖中，2为撮合中，3为询价中
        'matchable': false, // 去撮合按钮的显示隐藏
        'is_self_brand': true, // 是否是本品
        'enquiring': true, // 是否在询价中
        'date': '2017-01-10',
        'car_model_name': '汉兰达/2015款2.0T两驱精英版 5座',
        'car_image': 'http://img3.bitautoimg.com/autoalbum/files/20150324/003/16465300339630_3948382_2.jpg', // 车辆照片
        'actual_paid_amount': 2656500 // 实收金额，单位分
      },
      {
        'auction_car_id': 6, // 车辆id
        'latest_auction_id': 123, // 去撮合的id
        'status': 3, // 1、库存；2、已售 3、撮合已售
        'ongoing_status': 0, // 0为只在库，1为拍卖中，2为撮合中，3为询价中
        'auction_matchable': false, // 可否流拍撮合
        'enquiry_matchable': false, // 可否询价撮合
        'is_self_brand': true, // 是否是本品
        'enquiring': true, // 是否在询价中
        'date': '2015-11-11',
        'car_model_name': '汉兰达/2015款2.0T两驱精英版 5座',
        'car_image': 'http://img3.bitautoimg.com/autoalbum/files/20150324/003/16465300339630_3948382_2.jpg', // 车辆照片
        'actual_paid_amount': 2656500 // 实收金额，单位分
      },
      {
        'auction_car_id': 7, // 车辆id
        'latest_auction_id': 123, // 去撮合的id
        'status': 2, // 1、库存；2、已售 3、撮合已售
        'ongoing_status': 0, // 0为只在库，1为拍卖中，2为撮合中，3为询价中
        'auction_matchable': false, // 可否流拍撮合
        'enquiry_matchable': false, // 可否询价撮合
        'is_self_brand': true, // 是否是本品
        'enquiring': true, // 是否在询价中
        'date': '2017-01-10',
        'car_model_name': '汉兰达/2015款2.0T两驱精英版 5座',
        'car_image': 'http://img3.bitautoimg.com/autoalbum/files/20150324/003/16465300339630_3948382_2.jpg', // 车辆照片
        'actual_paid_amount': 2656500 // 实收金额，单位分
      },
      {
        'auction_car_id': 8, // 车辆id
        'latest_auction_id': 123, // 去撮合的id
        'status': 2, // 1、库存；2、已售 3、撮合已售
        'ongoing_status': 0, // 0为只在库，1为拍卖中，2为撮合中，3为询价中
        'auction_matchable': false, // 可否流拍撮合
        'enquiry_matchable': false, // 可否询价撮合
        'is_self_brand': true, // 是否是本品
        'enquiring': true, // 是否在询价中
        'date': '2015-11-11',
        'car_model_name': '汉兰达/2015款2.0T两驱精英版 5座',
        'car_image': 'http://img3.bitautoimg.com/autoalbum/files/20150324/003/16465300339630_3948382_2.jpg', // 车辆照片
        'actual_paid_amount': 2656500 // 实收金额，单位分
      },
      {
        'auction_car_id': 9, // 车辆id
        'latest_auction_id': 123, // 去撮合的id
        'status': 2, // 1、库存；2、已售 3、撮合已售
        'ongoing_status': 0, // 0为只在库，1为拍卖中，2为撮合中，3为询价中
        'matchable': false, // 去撮合按钮的显示隐藏
        'is_self_brand': true, // 是否是本品
        'enquiring': true, // 是否在询价中
        'date': '2017-01-10',
        'car_model_name': '汉兰达/2015款2.0T两驱精英版 5座',
        'car_image': 'http://img3.bitautoimg.com/autoalbum/files/20150324/003/16465300339630_3948382_2.jpg', // 车辆照片
        'actual_paid_amount': 2656500 // 实收金额，单位分
      },
      {
        'auction_car_id': 10, // 车辆id
        'latest_auction_id': 123, // 去撮合的id
        'status': 1, // 1、库存；2、已售 3、撮合已售
        'ongoing_status': 0, // 0为只在库，1为拍卖中，2为撮合中，3为询价中
        'auction_matchable': false, // 可否流拍撮合
        'enquiry_matchable': false, // 可否询价撮合
        'is_self_brand': true, // 是否是本品
        'enquiring': true, // 是否在询价中
        'date': '2015-11-11',
        'car_model_name': '汉兰达/2015款2.0T两驱精英版 5座',
        'car_image': 'http://img3.bitautoimg.com/autoalbum/files/20150324/003/16465300339630_3948382_2.jpg', // 车辆照片
        'actual_paid_amount': 2656500 // 实收金额，单位分
      },
      {
        'auction_car_id': 11, // 车辆id
        'latest_auction_id': 123, // 去撮合的id
        'status': 2, // 1、库存；2、已售 3、撮合已售
        'ongoing_status': 0, // 0为只在库，1为拍卖中，2为撮合中，3为询价中
        'auction_matchable': false, // 可否流拍撮合
        'enquiry_matchable': false, // 可否询价撮合
        'is_self_brand': true, // 是否是本品
        'enquiring': true, // 是否在询价中
        'date': '2017-01-10',
        'car_model_name': '汉兰达/2015款2.0T两驱精英版 5座',
        'car_image': 'http://img3.bitautoimg.com/autoalbum/files/20150324/003/16465300339630_3948382_2.jpg', // 车辆照片
        'actual_paid_amount': 2656500 // 实收金额，单位分
      },
      {
        'auction_car_id': 12, // 车辆id
        'latest_auction_id': 123, // 去撮合的id
        'status': 1, // 1、库存；2、已售 3、撮合已售
        'ongoing_status': 0, // 0为只在库，1为拍卖中，2为撮合中，3为询价中
        'auction_matchable': false, // 可否流拍撮合
        'enquiry_matchable': false, // 可否询价撮合
        'is_self_brand': true, // 是否是本品
        'enquiring': true, // 是否在询价中
        'date': '2015-11-11',
        'car_model_name': '汉兰达/2015款2.0T两驱精英版 5座',
        'car_image': 'http://img3.bitautoimg.com/autoalbum/files/20150324/003/16465300339630_3948382_2.jpg', // 车辆照片
        'actual_paid_amount': 2656500 // 实收金额，单位分
      },
      {
        'auction_car_id': 13, // 车辆id
        'latest_auction_id': 123, // 去撮合的id
        'status': 2, // 1、库存；2、已售 3、撮合已售
        'ongoing_status': 0, // 0为只在库，1为拍卖中，2为撮合中，3为询价中
        'auction_matchable': false, // 可否流拍撮合
        'enquiry_matchable': false, // 可否询价撮合
        'is_self_brand': true, // 是否是本品
        'enquiring': true, // 是否在询价中
        'date': '2017-01-10',
        'car_model_name': '汉兰达/2015款2.0T两驱精英版 5座',
        'car_image': 'http://img3.bitautoimg.com/autoalbum/files/20150324/003/16465300339630_3948382_2.jpg', // 车辆照片
        'actual_paid_amount': 2656500 // 实收金额，单位分
      },
      {
        'auction_car_id': 14, // 车辆id
        'latest_auction_id': 123, // 去撮合的id
        'status': 1, // 1、库存；2、已售 3、撮合已售
        'ongoing_status': 0, // 0为只在库，1为拍卖中，2为撮合中，3为询价中
        'auction_matchable': false, // 可否流拍撮合
        'enquiry_matchable': false, // 可否询价撮合
        'enquiring': true, // 是否在询价中
        'is_self_brand': true, // 是否是本品
        'date': '2015-11-11',
        'car_model_name': '汉兰达/2015款2.0T两驱精英版 5座',
        'car_image': 'http://img3.bitautoimg.com/autoalbum/files/20150324/003/16465300339630_3948382_2.jpg', // 车辆照片
        'actual_paid_amount': 2656500 // 实收金额，单位分
      }
    ]
  }
})

// 车辆拍卖列表
Mock.mock(/\/auctions\?/, 'get' + mockSwitch, {
  'code': 0,
  'data': {
    'auctions': [{
      'auction_car': {
        'car_image_url': 'https://test-images-cdn.cheanjia.com/zhongsheng/qiye_image/28iW6XVXNALtGswt9N7GbG.jpg',
        'car_info_id': 2146,
        'car_model_name': '丰田 RAV4荣放 2009款 2.0L 手动 经典版',
        'id': 1194,
        'licensed_issued_on': '2018-04-04',
        'location_city': '深圳',
        'mileage': 200000
      },
      'auction_session': {
        'auction_count': 5,
        'ended_at': null,
        'id': 358,
        'name': '2018年04月04日 23:54场',
        'started_at': '2018-04-04 23:54:00',
        'status': 1,
        'status_code': 'not_started'
      },
      'id': 1205,
      'maximum_price': 0,
      'minimum_price': 1000000,
      'mp_share_url': 'https://ucwx.test.dos.cheanjia.net/#/aucCar/1205/all',
      'order_id': 123,
      'reserve_price': 1500000,
      'sequence': 3,
      'status': 1,
      'status_code': 'sold',
      'store_name': '中升测试环境店'
    }, {
      'auction_car': {
        'car_image_url': 'https://test-images-cdn.cheanjia.com/zhongsheng/qiye_image/28iW6XVXNALtGswt9N7GbG.jpg',
        'car_info_id': 2147,
        'car_model_name': '丰田 RAV4荣放 2009款 2.0L 手动 经典版',
        'id': 1195,
        'licensed_issued_on': '2018-04-04',
        'location_city': '深圳',
        'mileage': 200000
      },
      'auction_session': {
        'auction_count': 5,
        'ended_at': null,
        'id': 358,
        'name': '2018年04月04日 23:54场',
        'started_at': '2018-04-04 23:54:00',
        'status': 1,
        'status_code': 'not_started'
      },
      'id': 1206,
      'maximum_price': 0,
      'minimum_price': 1000000,
      'mp_share_url': 'https://ucwx.test.dos.cheanjia.net/#/aucCar/1206/all',
      'order_id': 123,
      'reserve_price': 1500000,
      'sequence': 4,
      'status': 1,
      'status_code': 'sold',
      'store_name': '中升测试环境店'
    }],
    'count': 20,
    'page': 1,
    'total_count': 9
  },
  'message': 'ok'
})

// 车辆详情
Mock.mock(/auctions\/auction_cars\/\d+/, 'get' + mockSwitch, {
  'code': 0,
  'message': 'ok',
  'data': {
    'auction_car_id': 1, // 车辆编号
    'auction_car_info_id': 2, // 当车况需要编辑的时候，此参数附带在请求路径中，向后台请求一个预创建的car_info_id, 具体见【新增车辆/创建新的车辆信息快照】
    'status': 6, //  车辆状态，详细说明如上
    'ongoing_status': 1, // 只在库/拍卖中/撮合中/询价中
    'car_image_url': 'http://img3.bitautoimg.com/autoalbum/files/20150324/003/16465300339630_3948382_2.jpg', // 车辆照片
    'car_model_name': '汉兰达/2015款2.0T两驱精英版 5座', // 车型名称
    'vin': 'LAV18382898282822', // 车架号
    'plate_number': '粤B12111', // 车牌号
    'license_issued_on': '2016-16-15', // 新车交车日期
    'mileage': 56885, // 行驶里程，单位公里
    'car_color': '黑色', // 车身颜色
    'transfer_count': 1, // 过户次数
    'belonged_province': '广东', // 归属地-省
    'belonged_city': '深圳', // 归属地-市
    'channel': 1, // 渠道
    'maximum_price': 1100000, // 最高报价, 单位分，可能为空
    'enquiry_id': 1, // 询价id,用以查看最高报价所属的某次报价信息
    'contract_price': 1000000, // 收车实价，可为空
    'winning_price': '1100000', // 中标金额，单位分，可为空
    'actual_paid_amount': 100000, // 实收金额，单位分
    'auction_id': 1, // 拍卖id,可用于查询出价信息
    //  以下字段为当车辆为撮合已售时才存在
    'match_id': 11, // 撮合id
    'maximum_quote_price': 1111111, // 最高拍卖出价
    'match_price': 111111, // 撮合价格
    'actual_match_price': 11111, // 实收金额
    'enquiring': true,
    'batch_sale': {
      'car_income': 10000,
      'images': [
        {
          'code': 'id_card_a',
          'src': Mock.Random.dataImage('200x100')
        }
      ],
      'remark': '作废铁卖了',
      'transaction_date': '2017-11-8',
      'car_cost': 1234500,
      'buyer_mobile': '13800138000',
      'buyer_name': '张三',
      'dealer_name': 'king的店',
      'dealer_type': 'lixin'
    },
    'retail': {
      'car_income': 10000,
      'images': [
        {
          'code': 'id_card_a',
          'name': '合同价格',
          'src': Mock.Random.dataImage('200x100')
        }
      ],
      'remark': '作废铁卖了',
      'transaction_date': '2017-11-8',
      'buyer_mobile': '13800138000',
      'buyer_name': '张三',
      'car_cost': 12345,
      'car_gross_profit': 1000,
      'deal_price': 10000,
      'employee_id': 123,
      'employee_name': '张三',
      'maintenance_cost': 10000,
      'other_cost': 10000,
      'transfer_fee': 10000
    },
    'scrap': {
      // 'car_gross_profit': 1000,
      'car_income': 10000,
      'images': [
        {
          'code': 'id_card_a',
          'src': Mock.Random.dataImage('200x100')
        }
      ],
      'remark': '作废铁卖了',
      'transaction_date': '2017-11-8',
      'car_cost': 10000
    },
    'special': {
      'buyer_mobile': '13800138000',
      'buyer_name': '张三',
      'car_cost': 10000,
      'car_income': 10000,
      'images': [
        {
          'code': 'id_card_a',
          'src': Mock.Random.dataImage('200x100')
        }
      ],
      'outbound_date': '2017-11-8',
      'remark': '作废铁卖了'
    }
  }
})
